import React, { useEffect, useState } from "react";
import { server } from "../../common";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import { useSelectAccess } from "../../store/stateFunctions";
import { FaListAlt } from "react-icons/fa";
import { CiClock1 } from "react-icons/ci";
import { MdOutlineDone } from "react-icons/md";
import { CgDanger } from "react-icons/cg";
import TableDashboard from "../Administration/TableDashboard";
import Graphdashboard from "../Administration/GraphDashboard";
import { NavLink } from "react-router-dom";

const DivisionDashboard = ({ role }) => {
  const [ganeshUtsav, setGaneshUtsav] = useState({});
  const [navratri, setNavratri] = useState({});
  const [shivJayanti, setShivJayanti] = useState({});
  const [other, setOther] = useState({});
  const [ambedkarJayanti, setambedkarJayanti] = useState({});

  const user = useSelectAccess(role);

  useEffect(() => {
    getDashboard();
  }, []);

  const getDashboard = () => {
    server
      .get("/division/statuswise", {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        // const data = response.data[0];
        setGaneshUtsav(response.data.ganesh_utsav);
        setNavratri(response.data.navratri);
        setShivJayanti(response.data.shiv_jayanti);
        setambedkarJayanti(response.data.ambedkar_jayanti);
        setOther(response.data.other);
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message) {
          toast.error(error.response.data.message);
        } else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else {
          console.log("Failed to connect to server");
        }
      });
  };

  const renderCard = (title, data) => (
    <div className="card mb-4 shadow border-0">
      <div className={`card-header bg-danger text-white py-3`}>
        <h5 className="mb-0 fw-bold">{title}</h5>
      </div>
      <div className="card-body">
        <div className="row g-4">
          <div className="col-md-3 col-6">
            <NavLink className="text-decoration-none">
              <div className="text-center p-3 rounded bg-light h-100">
                <FaListAlt className="display-5 text-primary mb-3" />
                <h4 className="fs-2">{data?.totalAppl}</h4>
                <p>Total Applications</p>
              </div>
            </NavLink>
          </div>

          <div className="col-md-3 col-6">
            <div className="text-center p-3 rounded bg-light h-100">
              <CiClock1 className="display-5 text-warning mb-3" />
              <h4 className="fs-2">{data?.pendingAppl}</h4>
              <p>Pending Applications</p>
            </div>
          </div>

          <div className="col-md-3 col-6">
            <NavLink className="text-decoration-none">
              <div className="text-center p-3 rounded bg-light h-100">
                <MdOutlineDone className="display-5 text-success mb-3" />
                <h4 className="fs-2">{data?.approvedAppl}</h4>
                <p>Approved Applications</p>
              </div>
            </NavLink>
          </div>

          <div className="col-md-3 col-6">
            <div className="text-center p-3 rounded bg-light h-100">
              <CgDanger className="display-5 text-danger mb-3" />
              <h4 className="fs-2">{data?.rejectedAppl}</h4>
              <p>Rejected Applications</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="container my-5">
      <TableDashboard role={role} />
      <div className="container mt-4">
        {renderCard("गणेश उत्सव", ganeshUtsav)}
        {renderCard("नवरात्री उत्सव", navratri)}
        {renderCard("छत्रपती शिवाजी महाराज जयंती", shivJayanti)}{" "}
        {renderCard("डॉ. बाबासाहेब आंबेडकर जयंती", ambedkarJayanti)}
        {renderCard("Other", other)}
      </div>

      <Graphdashboard role={role} />
    </div>
  );
};

export default DivisionDashboard;
